<script>
import Panel from '@phoenix/mixins/components/common/Panel';
import { PhxsgButton } from '@sg/src/View/Components/Atoms/Button';
import { PhxsgHeading } from '@sg/src/View/Components/Atoms/Heading';

export default {
  components: { PhxsgButton, PhxsgHeading },

  mixins: [Panel],

  props: {
    twoColumns: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    _headerClasses() {
      return ['panel__header', { 'panel__header--bordered': this.headerBordered }, ...this.headerClasses];
    },

    _wrapperClasses() {
      return [...this._classes, { 'panel--two-columns': this.twoColumns }];
    },
  },
};
</script>

<template>
  <div :id="id" :class="_wrapperClasses" aria-hidden="true">
    <div class="panel__overlay" :data-panel-close="id"></div>

    <div v-if="twoColumns" class="panel__column-start panel__body">
      <div class="panel__content">
        <slot name="start" />
      </div>
    </div>

    <div class="panel__body" :class="{ 'panel__column-end': twoColumns }">
      <header :class="_headerClasses">
        <phxsg-heading use="span" variant="h4">{{ title }}</phxsg-heading>

        <phxsg-button
          class="panel__close-btn"
          icon-only
          icon-id="close"
          data-cy="panel-close"
          :data-panel-close="id"
          :label="$t('Accessibility.modal.close')"
        />
      </header>

      <div :class="_contentClasses">
        <slot name="content" />
      </div>

      <footer v-if="hasFooterSlot" class="panel__footer">
        <slot name="footer" />
      </footer>
    </div>
  </div>
</template>
